const hostname = window.location.hostname;
export const isLocal = hostname === 'localhost';
export const isStaging = hostname === 'ben.thanksben.dev';
export const isLocalOrStaging = isLocal || isStaging;

const subdomainOverride =
  isLocalOrStaging && window.location.search.match(/subdomain=([a-z-]+)/i)?.[1];

const subdomain = subdomainOverride || hostname.split('.')[0];

const HSBC_SUB_DOMAIN = 'thrivebenefits';

export const isHSBCInstance =
  subdomain.includes(HSBC_SUB_DOMAIN) || subdomain?.includes('hsbc-demo2');

const mewsSubdomains = 'mews';
export const isMewsEmployer = subdomain.includes(mewsSubdomains);
